// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3HQ4C","requiredAsterisk":"Info_requiredAsterisk__2RajO"};